<template>
  <div class="detalhes-por-vereador">
    <div class="row">
      <PublicHeader :title="vereador">
        <div class="col-xs-12 col-sm-6">
          <p>
            Aqui você encontra as emendas parlamentares do(a) vereador(a)
            <ValorDestaqueHeader :value="vereador" />.
          </p>
          <p>
            No ano de <SelectAnoEmendas />, foram repassados
            <ValorDestaqueHeader
              :value="formatarMoeda(valorTotalEmendas)"
              :isLoading="loading"
            />
            em emendas parlamentares, dos quais
            <ValorDestaqueHeader
              :value="formatarMoeda(valorUtilizadoEmendas)"
              :isLoading="loading"
            />
            já foram utilizados, restando um saldo de
            <ValorDestaqueHeader
              :value="formatarMoeda(saldoTotalEmendas)"
              :isLoading="loading"
            />.
          </p>
        </div>
      </PublicHeader>
    </div>
    <div class="container">
      <Breadcrumb :links="breadcrumb" />
      <div class="row">
        <div class="col-xs-12">
          <h3>
            Lista de Emendas
          </h3>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-sm-6">
          <input
            type="text"
            class="form-control"
            placeholder="Digite a secretaria ou descrição..."
            aria-placeholder="Digite a secretaria ou descrição..."
            v-model="filtros.descricao"
          />
        </div>
        <div class="col-xs-12 col-sm-6 text-right">
          <button class="btn btn-default" @click="downloadToCSV()">
            <font-awesome-icon :icon="'file-download'" /> Exportar para CSV
          </button>
        </div>
        <div class="col-xs-12">
          <DataTable :dados="emendasDoVereador" :fields="dataFields">
            <template slot="rowrender" slot-scope="props">
              <button
                title="Exibir detalhes"
                type="button"
                class="btn btn-primary"
                @click="showDetails(props.rowData)"
              >
                <font-awesome-icon :icon="'search'"></font-awesome-icon>
                <span class="sr-only">Exibir detalhes</span>
              </button>
            </template>
          </DataTable>
        </div>
      </div>
    </div>
    <SideEmendas ref="side-emendas" :emenda="emendaSelecionada" :navs="navs" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {
  PublicHeader,
  Breadcrumb,
  NoApiTable as DataTable,
  SideEmendas,
  SelectAnoEmendas,
  ValorDestaqueHeader
} from '../../../components'
import { formatarMoeda, exportCSVFile } from '../../../utils'
import { navs, dataFields } from './emendasGeral'

export default {
  components: {
    PublicHeader,
    Breadcrumb,
    DataTable,
    SideEmendas,
    SelectAnoEmendas,
    ValorDestaqueHeader
  },
  data() {
    return {
      vereador: '',
      breadcrumb: [],
      navs,
      dataFields,
      emendaSelecionada: {},
      filtros: {
        descricao: ''
      }
    }
  },
  created() {
    const { vereador } = this.$route.params
    this.vereador = vereador

    this.fillBreadcrumb()
  },
  methods: {
    formatarMoeda,
    showDetails(emenda) {
      const [nav] = this.navs

      nav.titulo = `Detalhes da emenda`
      nav.subtitulo = `Emenda nº ${emenda.numero} / ${emenda.ano}`
      nav.subtDetalhe = emenda.nome_orgao
      this.emendaSelecionada = emenda

      this.$refs['side-emendas'].$emit('abreModal', nav.identidade)
    },
    fillBreadcrumb() {
      this.breadcrumb = [
        {
          label: 'Emendas Parlamentares',
          named_link: { name: 'emendas_parlamentares' }
        },
        {
          label: 'Emendas Por Vereador',
          named_link: { name: 'emendas_por_vereador' }
        },
        {
          label: this.vereador
        }
      ]
    },
    reducer: key => (acum, emenda) => {
      return (acum += Number(emenda[key]))
    },
    downloadToCSV() {
      const headers = {
        numero: 'Emenda nº',
        vereador: 'Vereador',
        secretaria: 'Secretaria',
        descricao: 'Descrição',
        valor: 'Valor',
        saldo: 'Saldo'
      }

      exportCSVFile(
        headers,
        [
          ...this.emendasDoVereador.map(item => {
            return {
              numero: item.numero,
              vereador: item.vereador.nome,
              secretaria: item.nome_orgao,
              descricao: item.descricao,
              valor: Number(item.valor)
                .toFixed(2)
                .replace('.', ','),
              saldo: Number(item.saldo)
                .toFixed(2)
                .replace('.', ',')
            }
          })
        ],
        'emendas'
      )
    }
  },
  computed: {
    ...mapState({
      emendas: state => state.emendas_parlamentares.emendas,
      loading: ({ emendas_parlamentares }) => emendas_parlamentares.loading
    }),
    emendasDoVereador() {
      const filter = emenda => {
        return emenda.vereador.nome === this.vereador
      }

      const emendasVereador = this.emendas.filter(filter)

      if (this.filtros.descricao) {
        const filter = item => {
          const { sigla_orgao, descricao } = item

          const termo = this.filtros.descricao.toUpperCase()
          return (
            sigla_orgao.toUpperCase().includes(termo) ||
            descricao.toUpperCase().includes(termo)
          )
        }

        return emendasVereador.filter(filter)
      }

      return emendasVereador
    },
    valorTotalEmendas() {
      return this.emendasDoVereador.reduce(this.reducer('valor'), 0)
    },
    saldoTotalEmendas() {
      return this.emendasDoVereador.reduce(this.reducer('saldo'), 0)
    },
    valorUtilizadoEmendas() {
      return this.valorTotalEmendas - this.saldoTotalEmendas
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/public/emendas_parlamentares/DetalhesPorVereador.vue